import React, {Component} from 'react';
import _ from 'lodash';
import moment from 'moment';

import StateViewer from 'components/StateViewer';
import Api from 'util/Api';
import PatientForm from './_form';
import StyledSelect from 'components/StyledSelect';
import RadioToggle from 'components/RadioToggle';
import RespForm from './_rrsetting';

class PatientNew extends Component {
    constructor(props) {
        super(props);

        const startingDate = moment().subtract(65, 'years');

        const defaultbedexit = {
            active: false,
            allday: false,
            rangeend_timeofday: "08:00",
            rangestart_timeofday: "22:00",
            span: 120,
            timezone: "America/New_York"};

        const defaultrr = {
            active: true,
            high: 21,
            high_urgent: 21,
            normal:16,
            low: 15,
            very_low: 15,
            high_urgent_alert_time: 60,
            high_warn_alert_time: 30,
            low_urgent_alert_time: 60,
            low_warn_alert_time: 30,
            very_low_warn_alert_time: 10,
            very_low_urgent_alert_time: 60,
            very_high_warn_alert_time:30,
            very_high_urgent_alert_time:60
        };
        const defaultvisit = {
            active: true,
            require_visit: 60,
            visit_soon: 20
        };
        const defaultSetting = {
            bedexit:defaultbedexit,
            rr:defaultrr,
            visit:defaultvisit,
        };

        this.state = {
            availableRooms: [],
            originalPatient: {
                firstName: '',
                middleName: '',
                lastName: '',
                dob: startingDate,
                forms: [],
            },
            patient: {
                firstName: '',
                middleName: '',
                lastName: '',
                dob: startingDate,
                forms: [],
            },
            isSubmitting: false,
            saveChangesButtonText: 'Save',
            requiredFieldClasses: {
                firstName: 'required',
                lastName: 'required',
                gender: 'required',
                dob: 'required',
            },
            lowErrorOptions: _.times(31),
            highErrorOptions: _.times(31),
            current: {setting: defaultSetting},
            pending: {setting: defaultSetting},
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleAtRiskChange = this.handleAtRiskChange.bind(this);
        this.handleChangePatient = this.handleChangePatient.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSaveChanges = this.handleSaveChanges.bind(this);
        this.handleModalCancel = this.handleModalCancel.bind(this);
        this.handleModalConfirm = this.handleModalConfirm.bind(this);
        this.handleViewForm = this.handleViewForm.bind(this);
        this.validateRequired = this.validateRequired.bind(this);
        this.showModal = this.showModal.bind(this);
        this.handleRangeChange = this.handleRangeChange.bind(this);
        this.handleBooleanChange = this.handleBooleanChange.bind(this);
        this.handleNavigateTo = this.handleNavigateTo.bind(this);
        this.handleResetDefaultVisits = this.handleResetDefaultVisits.bind(this);
        this.handleResetDefaultRespiration = this.handleResetDefaultRespiration.bind(this);
        this.handleResetDefaultBedExit = this.handleResetDefaultBedExit.bind(this);
        this.handleLowWarnToggle = this.handleLowWarnToggle.bind(this);
        this.handleHighWarnToggle = this.handleHighWarnToggle.bind(this);
        this.handleCancelChanges = this.handleCancelChanges.bind(this);
        this.handleBedExitDisabled = this.handleBedExitDisabled.bind(this);
        this.handlBedExit24Hours = this.handlBedExit24Hours.bind(this);
    }

    handleCancelChanges() {
        this.props.history.push(`/facilities/${this.props.match.params.facility}/sections/${this.props.match.params.section}/patients`, {message: ''});
    }

    componentDidMount() {
        Api.withAuth(this.props.auth).getBedsNoIndex(this.props.match.params).then((data) => this.setState({
            availableRooms: _(data)
                .filter(({id, occupied}) => id === this.state.patient.bed || !occupied)
                .sortBy('name')
                .value(),
        })
        );


        Api.withAuth(this.props.auth).getDefaultSetting({id:this.props.match.params.facility}).then((data) => {
            console.log(data);
            this.setState({
                current: {
                    ...this.state.current,
                    setting: data
                },
                pending: {
                    ...this.state.current,
                    setting: data
                }
            });
        });
    }

    validateRequired({target}) {
        if (_.includes(_.keys(this.state.requiredFieldClasses), target.name)) {
            this.setState({
                requiredFieldClasses: {
                    ...this.state.requiredFieldClasses,
                    [target.name]: `required ${_.isEmpty(target.value) ? 'invalid' : ''}`
                }
            });
        }
    }

    handleSaveChanges() {
        this.setState({
            isSubmitting: true,
            saveChangesButtonText: 'Saving...',
        });

        console.log(this.state.current.setting);

        // Extract just the filename for the patients forms
        const patientToSave = {
            ...this.state.patient,
            forms: this.state.patient.forms.map((form) => form.filename),
        };

        Api.withAuth(this.props.auth).createPatient({...this.props.match.params, patient: patientToSave})
            .then((data) => {
                Api.withAuth(this.props.auth).setSetting({id: data.id, setting: this.state.current.setting}).then((data2) => {
                    this.setState({
                        isSubmitting: false,
                        saveChangesButtonText: 'Saved!',
                    });
                    this.props.history.push(`/facilities/${this.props.match.params.facility}/sections/${this.props.match.params.section}/patients`, {message: 'Added new resident'});
                });
            });
    }

    handleChangePatient({target}) {
        let targetValue = target.value;

        if (target.type === 'checkbox') { targetValue = target.checked; }

        this.setState({
            patient: {
                ...this.state.patient,
                [target.name]: targetValue,
            }
        });
    }

    handleChange({target}) {
        const current = _.cloneDeep(this.state.current);
        _.set(current, target.name, target.value);

        this.setState({
            current: {
                ...current,
            }
        });
        let targetValue = target.value;

        if (target.type === 'checkbox') { targetValue = target.checked; }

        this.setState({
            patient: {
                ...this.state.patient,
                [target.name]: targetValue
            }
        }, () => this.setState({
            originalPatient: {
                ...this.state.originalPatient,
                forms: this.state.patient.forms,
            }
        }));
    }
    handleAtRiskChange({target}) {
        const current = _.cloneDeep(this.state.current);
        let targetValue = target.value;
        if(target.textContent !== '') {
            target.name = 'atRisk';
            _.set(current, "patient.atRisk", (target.textContent==="Off" ? true : false));
            targetValue = (target.textContent==="Off" ? true : false);

            this.setState({
                current: {
                    ...current,
                }
            });


            this.setState({
                patient: {
                    ...this.state.patient,
                    'atRisk': targetValue
                }
            }, () => this.setState({
                originalPatient: {
                    ...this.state.originalPatient,
                    forms: this.state.patient.forms,
                }
            }));
        }
    }

    handleRangeChange({target}) {
        const current = _.cloneDeep(this.state.current);
        _.set(current, target.name, Number(target.value));

        if (target.name.endsWith('_urgent')) {
            const coTarget = `${target.name.split('_urgent')[0]}`;

            if (_.get(this.state.current, coTarget) === _.get(this.state.current, target.name)) {
                _.set(current, coTarget, Number(target.value));
            }
        }

        if (target.name.endsWith('normal')) {
            console.log(Number(target.value));
            const highWarn = _.get(this.state, 'current.setting.rr.high');
            if (highWarn) {
                _.set(current, 'setting.rr.high', Number(target.value) + 1);
            } else {
                _.set(current, 'setting.rr.high_urgent', Number(target.value) + 1);
            }
        }

        this.setState({
            current: {
                ...current,
            }
        });
    }

    handleBooleanChange({target}) {
        const value = JSON.parse(target.value);

        this.setState({
            pending: {
                ...this.state.pending,
                [target.name]: value,
            }
        });
    }

    handleNavigateTo(event, destination) {
        if (_.isEqual(this.state.current, this.state.pending)) {
            this.props.history.push(destination);
        } else {
            this.showModal('NAVIGATE', () => this.props.history.push(destination));
        }

        event.preventDefault();
        return false;
    }

    handleResetDefaultVisits() {
        const current = _.cloneDeep(this.state.current);
        this.showModal('RESET_VISITS', () => {
            _.set(current, 'setting.visit', this.state.pending.setting.visit);

            this.setState({
                current: {
                    ...current
                }
            });
        });
    }

    handleResetDefaultRespiration() {
        const current = _.cloneDeep(this.state.current);
        this.showModal('RESET_RESPIRATION', () => {
            _.set(current, 'setting.rr', this.state.pending.setting.rr);

            this.setState({
                current: {
                    ...current
                }
            });
        });
    }

    handleResetDefaultBedExit() {
        const current = _.cloneDeep(this.state.current);
        this.showModal('RESET_BEDEXIT', () => {
            _.set(current, 'setting.bedexit', this.state.pending.setting.bedexit);

            this.setState({
                current: {
                    ...current
                }
            });
        });
    }

    handleLowWarnToggle() {
        const current = _.cloneDeep(this.state.current);
        const lowError = _.get(this.state, 'current.setting.rr.low');
        const lowErrorvery_low_warn_alert_time = _.get(this.state, 'current.setting.rr.low_warn_alert_time');
        const lowErrorvery_low_urgent_alert_time = _.get(this.state, 'current.setting.rr.low_urgent_alert_time');
        const lowErrorlow_warn_alert_time = _.get(this.state, 'current.setting.rr.low_warn_alert_time');
        const highErrorhigh_warn_alert_time = _.get(this.state, 'current.setting.rr.high_warn_alert_time');
        const highErrorvery_high_warn_alert_time = _.get(this.state, 'current.setting.rr.high_warn_alert_time');
        const highErrorvery_high_urgent_alert_time = _.get(this.state, 'current.setting.rr.high_urgent_alert_time');
        const normal = _.get(this.state, 'current.setting.rr.normal');
        const lowWarn = 0; //_.get(this.state, 'current.setting.rr.low');
        const highWarn = 0; //_.get(this.state, 'current.setting.rr.high');


        if (lowError === lowWarn) {
            if (lowError === highWarn - 2) {
                _.set(current, "setting.rr.low", highWarn - 2);
                _.set(current, "setting.rr.very_low", highWarn - 3);
            } else if (lowError === _.max(this.state.lowErrorOptions)) {
                _.set(current, "setting.rr.low", lowError);
                _.set(current, "setting.rr.very_low", lowError - 1);
            } else {
                _.set(current, "setting.rr.low", lowError + 1);
            }
        }
        /*else {
            _.set(current, "setting.rr.low", lowError);
        }*/
        this.setState({
            current: {
                ...current,
            }
        });
    }

    handlBedExit24Hours(target) {
        const current = _.cloneDeep(this.state.current);
        _.set(current, "setting.bedexit.allday", (target.currentTarget.textContent==="Off" ? true : false));

        this.setState({
            current: {
                ...current,
            }
        });
    }

    handleBedExitDisabled(target) {
        const current = _.cloneDeep(this.state.current);
        _.set(current, "setting.bedexit.active", (target.currentTarget.textContent==="Off" ? true : false));

        this.setState({
            current: {
                ...current,
            }
        });
    }

    handleHighWarnToggle() {
        const current = _.cloneDeep(this.state.current);
        const lowWarn = _.get(this.state, 'current.setting.rr.low');
        const highWarn = _.get(this.state, 'current.setting.rr.high');
        const highError = _.get(this.state, 'current.setting.rr.high_urgent');
        const normal = _.get(this.state, 'current.setting.rr.normal');

        if (highError === highWarn) {
            if (highError === lowWarn + 2) {
                _.set(current, "setting.rr.high", lowWarn + 2);
                _.set(current, "setting.rr.high_urgent", lowWarn + 3);
            } else if (highError === _.min(this.state.highErrorOptions)) {
                _.set(current, "setting.rr.high", highError);
                _.set(current, "setting.rr.high_urgent", highError + 1);
            } else {
                _.set(current, "setting.rr.high", highError - 1);
            }
        }
        /*else {
            _.set(current, "setting.rr.high", highError);
        }*/

        this.setState({
            current: {
                ...current,
            }
        });
    }

    handleCancel() {
        const action = () => this.props.history.push(`/facilities/${this.props.match.params.facility}/sections/${this.props.match.params.section}/patients`);

        if (this.hasPendingChanges()) {
            this.setState({
                isModalVisible: true,
                modalQuestion: 'NAVIGATE',
                modalConfirmAction: action,
            });
        } else {
            action();
        }
    }

    handleModalCancel() {
        this.setState({
            isModalVisible: false,
            modalQuestion: null,
            modalConfirmAction: _.noop,
        });
    }

    handleModalConfirm() {
        const action = this.state.modalConfirmAction;

        this.setState({
            isModalVisible: false,
            modalQuestion: null,
            modalConfirmAction: _.noop,
        }, action);
    }

    handleViewForm({url, filename}) {
        this.setState({
            isModalVisible: true,
            modalQuestion: 'PREVIEW',
            modalConfirmAction: _.noop,
            modalFileName: filename,
            modalFileUrl: url,
        });
    }

    showModal(name, action) {
        this.setState({
            isModalVisible: true,
            modalQuestion: name,
            modalConfirmAction: action
        });
    }

    hasPendingChanges() {
        return !_.isEqual(this.state.patient, this.state.originalPatient);
    }

    render() {
        const demo = this.props.auth.isDemoUser();
        const visitSoonTimerOptions = _.fill(Array(12), null).map((o, i) => (i + 1) * 10);

        const requiredMinutes = _.get(this.state, 'current.setting.visit.require_visit');
        const soonMinutes = _.get(this.state, 'current.setting.visit.visit_soon');
        const lowError = _.get(this.state, 'current.setting.rr.low');
        const lowWarn = 0; //_.get(this.state, 'current.setting.rr.low');
        const highWarn = 0; //_.get(this.state, 'current.setting.rr.high');
        const highError = _.get(this.state, 'current.setting.rr.high_urgent');
        const rrWarningTimerOptions = _.fill(Array(6), null).map((o, i) => (i + 1) * 10);
        const lowErrorvery_low_warn_alert_time = _.get(this.state, 'current.setting.rr.low_warn_alert_time');
        const lowErrorvery_low_urgent_alert_time = _.get(this.state, 'current.setting.rr.low_urgent_alert_time');
        const lowErrorlow_warn_alert_time = _.get(this.state, 'current.setting.rr.low_warn_alert_time');
        const highErrorhigh_warn_alert_time = _.get(this.state, 'current.setting.rr.high_warn_alert_time');
        const highErrorvery_high_warn_alert_time = _.get(this.state, 'current.setting.rr.high_warn_alert_time');
        const highErrorvery_high_urgent_alert_time = _.get(this.state, 'current.setting.rr.high_urgent_alert_time');
        const normal = _.get(this.state, 'current.setting.rr.normal');

        const changesPending = !_.isEqual(this.state.current, this.state.pending);
        const bedExitMinutes = _.get(this.state, 'current.setting.bedexit.span');
        const bedExitFrom = _.get(this.state, 'current.setting.bedexit.rangestart_timeofday');
        const bedExitTo = _.get(this.state, 'current.setting.bedexit.rangeend_timeofday');
        const bedExit24Hours = _.get(this.state, 'current.setting.bedexit.allday');
        const bedExitDisabled = _.get(this.state, 'current.setting.bedexit.active');
        const {lowErrorOptions, highErrorOptions} = this.state;
        const lowWarnOptions = this.state.lowErrorOptions;
        const highWarnOptions = this.state.highErrorOptions;
        const nomalRange = lowError + 1;

        let modalStyle = {};
        let modalHeader = 'Confirm';
        let modalText = 'Are you sure?';
        let modalCancelButtonText = 'No';
        let modalConfirmButtonText = 'Yes';

        let cancelButtonText = 'No, Cancel';
        let confirmButtonText = 'Yes';

        switch (this.state.modalQuestion) {
        case 'NAVIGATE':
            modalHeader = 'Unsaved Changes';
            modalText = 'You currently have unsaved changes. Are you sure you want to discard your changes?';
            modalCancelButtonText = 'Cancel';
            modalConfirmButtonText = 'Discard Changes';
            break;
        case 'PREVIEW':
            modalStyle = {width: '90%'};
            modalHeader = this.state.modalFileName;
            modalText = (
                <iframe title='Preview' className='form-preview' src={this.state.modalFileUrl} />
            );
            modalCancelButtonText = 'Close';
            modalConfirmButtonText = null;
            break;
        default:
            break;
        }

        const readyToSubmit = !this.state.isSubmitting && this.hasPendingChanges() &&
      !_(this.state.requiredFieldClasses)
          .keys()
          .map((field) => _.get(this.state.patient, field))
          .some(_.isEmpty);

        return (
            <div className='patient-new'>
                {false && <StateViewer value={this.state} startExpanded />}
                <div className='subnav fixed-top'>
                    <div className='container h-100'>
                        <div className='row d-flex align-items-center h-100'>
                            <h3 className='breadcrumb-link' onClick={this.handleCancel}>Residents</h3>
                            <span className='separator' />
                            <h3>New Resident</h3>
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card patient-demographics'>
                            <div className='card-header'>
                                Demographics
                            </div>

                            <div className='card-body'>
                                <PatientForm
                                    availableRooms={this.state.availableRooms}
                                    patient={this.state.patient}
                                    requiredFieldClasses={this.state.requiredFieldClasses}
                                    onChange={this.handleChangePatient}
                                    onChangeAtRisk={this.handleAtRiskChange}
                                    onValidateRequired={this.validateRequired}
                                />
                            </div>

                            {/*<div className='card-footer'>
                                <div className='actions row'>
                                    <div className='col-md-12 text-right'>
                                        <button className='btn btn-secondary mx-2 px-5' onClick={this.handleCancel}>Cancel</button>
                                        <button className='btn btn-primary mx-2 px-5'
                                            onClick={this.handleSaveChanges}
                                            disabled={!readyToSubmit || demo}
                                        >
                                            {this.state.saveChangesButtonText}
                                            {demo && ' [DEMO]'}
                                        </button>
                                    </div>
                                </div>
                            </div>*/}
                        </div>
                    </div>

                    {/*<div className='col-md-6'>
                        <div className='card'>
                            <div className='card-header'>
                                Forms
                            </div>

                            <div className='card-body'>
                                <PatientConsent
                                    auth={this.props.auth}
                                    patient={this.state.patient}
                                    onChange={this.handleChangepatient}
                                    onViewForm={this.handleViewForm}
                                />
                            </div>
                        </div>
                        </div>*/}
                </div>

                {false && <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header'>
                                Diagnosis
                            </div>

                            <div className='card-body'>
                                TBD
                            </div>
                        </div>
                    </div>
                </div>
                }

                <div className='room-settings'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='card'>
                                <div className='card-header'>
                                    Visit Tracker
                                </div>

                                <div className='card-body px-0 py-0 bed-exit'>
                                    <section>
                                        <div className="row">
                                            <div className="col-md-8">
                                                <label>
                                                    <div>
                                                        Required Visit Timer
                                                        <small>
                                                            This room <strong>must be visited</strong> every:
                                                        </small>
                                                    </div>
                                                </label>
                                            </div>
                                            <div className="col-md-4">
                                                <StyledSelect
                                                    className='form-control'
                                                    name='setting.visit.require_visit'
                                                    value={requiredMinutes}
                                                    onChange={this.handleChange} >
                                                    <option value={15}>15 Minutes</option>
                                                    <option value={30}>30 Minutes</option>
                                                    <option value={60}>1 Hour</option>
                                                    <option value={120}>2 Hours</option>
                                                    <option value={180}>3 Hours</option>
                                                    <option value={240}>4 Hours</option>
                                                    <option value={300}>5 Hours</option>
                                                    <option value={360}>6 Hours</option>
                                                </StyledSelect>
                                            </div>
                                        </div>
                                    </section>

                                    <section>
                                        <div className="row">
                                            <div className="col-md-8">
                                                <label>
                                                    <div>
                                                        Visit Soon Timer
                                                        <small>
                                                            Choose the amount of minutes before the Required Visit that the <strong>Visit Soon alert</strong> will be triggered.
                                                        </small>
                                                    </div>
                                                </label>
                                            </div>
                                            <div className="col-md-4">
                                                <StyledSelect
                                                    className='form-control'
                                                    name='setting.visit.visit_soon'
                                                    value={soonMinutes}
                                                    onChange={this.handleChange} >
                                                    {visitSoonTimerOptions.map((time) => (
                                                        <option key={time} value={time}>{time} Minutes</option>
                                                    ))}
                                                </StyledSelect>
                                            </div>
                                        </div>
                                    </section>
                                </div>

                                <div className='card-footer text-right'>
                                    <button className='btn btn-secondary' onClick={this.handleResetDefaultVisits}>Return to Default</button>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card">
                                <div className="card-header">
                                    Bed Exit
                                </div>

                                <div className='card-body px-0 py-0 bed-exit'>
                                    <section>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <label>
                                                    <div>
                                                        Bed Occupancy Time
                                                        <small>
                                                            Set the time range the <strong>resident will be in bed</strong>
                                                        </small>
                                                    </div>
                                                </label>
                                            </div>
                                            <div className="col-md-6">
                                                All Day&nbsp;
                                                <RadioToggle value={bedExit24Hours} onClick={this.handlBedExit24Hours} />
                                            </div>
                                            <div className="col-md-6">
                                                <div style={{display:'flex', alignItems:'center'}}>
                                                    <StyledSelect
                                                        disabled={bedExit24Hours}
                                                        className='form-control'
                                                        name='setting.bedexit.rangestart_timeofday'
                                                        value={bedExitFrom}
                                                        onChange={this.handleChange} >
                                                        <option value={"00:00"}>12:00 AM</option>
                                                        <option value={"01:00"}>1:00 AM</option>
                                                        <option value={"02:00"}>2:00 AM</option>
                                                        <option value={"03:00"}>3:00 AM</option>
                                                        <option value={"04:00"}>4:00 AM</option>
                                                        <option value={"05:00"}>5:00 AM</option>
                                                        <option value={"06:00"}>6:00 AM</option>
                                                        <option value={"07:00"}>7:00 AM</option>
                                                        <option value={"08:00"}>8:00 AM</option>
                                                        <option value={"09:00"}>9:00 AM</option>
                                                        <option value={"10:00"}>10:00 AM</option>
                                                        <option value={"11:00"}>11:00 AM</option>
                                                        <option value={"12:00"}>12:00 PM</option>
                                                        <option value={"13:00"}>1:00 PM</option>
                                                        <option value={"14:00"}>2:00 PM</option>
                                                        <option value={"15:00"}>3:00 PM</option>
                                                        <option value={"16:00"}>4:00 PM</option>
                                                        <option value={"17:00"}>5:00 PM</option>
                                                        <option value={"18:00"}>6:00 PM</option>
                                                        <option value={"19:00"}>7:00 PM</option>
                                                        <option value={"20:00"}>8:00 PM</option>
                                                        <option value={"21:00"}>9:00 PM</option>
                                                        <option value={"22:00"}>10:00 PM</option>
                                                        <option value={"23:00"}>11:00 PM</option>
                                                    </StyledSelect>
                                                    -
                                                    <StyledSelect
                                                        disabled={bedExit24Hours}
                                                        className='form-control'
                                                        name='setting.bedexit.rangeend_timeofday'
                                                        value={bedExitTo}
                                                        onChange={this.handleChange} >
                                                        <option value={"00:00"}>12:00 AM</option>
                                                        <option value={"01:00"}>1:00 AM</option>
                                                        <option value={"02:00"}>2:00 AM</option>
                                                        <option value={"03:00"}>3:00 AM</option>
                                                        <option value={"04:00"}>4:00 AM</option>
                                                        <option value={"05:00"}>5:00 AM</option>
                                                        <option value={"06:00"}>6:00 AM</option>
                                                        <option value={"07:00"}>7:00 AM</option>
                                                        <option value={"08:00"}>8:00 AM</option>
                                                        <option value={"09:00"}>9:00 AM</option>
                                                        <option value={"10:00"}>10:00 AM</option>
                                                        <option value={"11:00"}>11:00 AM</option>
                                                        <option value={"12:00"}>12:00 PM</option>
                                                        <option value={"13:00"}>1:00 PM</option>
                                                        <option value={"14:00"}>2:00 PM</option>
                                                        <option value={"15:00"}>3:00 PM</option>
                                                        <option value={"16:00"}>4:00 PM</option>
                                                        <option value={"17:00"}>5:00 PM</option>
                                                        <option value={"18:00"}>6:00 PM</option>
                                                        <option value={"19:00"}>7:00 PM</option>
                                                        <option value={"20:00"}>8:00 PM</option>
                                                        <option value={"21:00"}>9:00 PM</option>
                                                        <option value={"22:00"}>10:00 PM</option>
                                                        <option value={"23:00"}>11:00 PM</option>
                                                    </StyledSelect>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                    <section>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    Bed Exit Timer&nbsp;
                                                    <RadioToggle value={bedExitDisabled} onClick={this.handleBedExitDisabled} />
                                                </div>
                                            </div>
                                            <div className="col-md-8">
                                                <label>
                                                    <small>
                                                        Alert me if the resident has been <strong>out of the bed</strong> within the bed occupancy time for over
                                                    </small>
                                                </label>
                                            </div>
                                            <div className="col-md-4">
                                                <StyledSelect
                                                    disabled={!bedExitDisabled}
                                                    className='form-control'
                                                    name='setting.bedexit.span'
                                                    value={(bedExitMinutes)}
                                                    onChange={this.handleChange} >
                                                    <option value={120}>2 Minutes</option>
                                                    <option value={300}>5 Minutes</option>
                                                    <option value={600}>10 Minutes</option>
                                                    <option value={1200}>20 Minutes</option>
                                                    <option value={2400}>40 Minutes</option>
                                                    <option value={3600}>60 Minutes</option>
                                                </StyledSelect>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>

                            <div className='card-footer text-right'>
                                <button className='btn btn-secondary' onClick={this.handleResetDefaultBedExit}>Return to Default</button>
                            </div>
                        </div>
                    </div>
                    <RespForm
                        lowError={lowError}
                        lowWarnOptions={lowWarnOptions}
                        handleRangeChange={this.handleRangeChange}
                        lowErrorOptions={lowErrorOptions}
                        lowErrorvery_low_warn_alert_time={lowErrorvery_low_warn_alert_time}
                        handleResetDefaultRespiration={this.handleResetDefaultRespiration}
                        highErrorvery_high_urgent_alert_time={highErrorvery_high_urgent_alert_time}
                        highErrorvery_high_warn_alert_time={highErrorvery_high_warn_alert_time}
                        rrWarningTimerOptions={rrWarningTimerOptions}
                        normal={normal}
                        handleChange={this.handleChange}
                        nomalRange={nomalRange}
                        lowErrorvery_low_urgent_alert_time={lowErrorvery_low_urgent_alert_time}
                        lowWarn={lowWarn}
                    />
                    <div className='actions row'>
                        <div className='col-md-12 text-right'>
                            <button className='btn btn-secondary mx-2 px-5' onClick={this.handleCancelChanges} disabled={!readyToSubmit}>Cancel</button>
                            <button className='btn btn-primary mx-2 px-5' onClick={this.handleSaveChanges} disabled={!readyToSubmit || !this.hasPendingChanges || demo}>
                                {this.state.saveChangesButtonText}
                                {demo && ' [DEMO]'}
                            </button>
                        </div>
                    </div>

                    {this.state.isModalVisible &&
                        <div>
                            <div className='popup-wrapper' onClick={this.handleModalCancel} role='dialog'>
                                <div className='popup' onClick={(e) => e.stopPropagation()}>
                                    <span className='close' onClick={this.handleModalCancel}>Close</span>

                                    <h1>{modalHeader}</h1>
                                    <p>{modalText}</p>

                                    <div className='actions text-center'>
                                        <button className='btn btn-secondary mx-2 px-5' onClick={this.handleModalCancel}>{cancelButtonText}</button>
                                        <button className='btn btn-primary mx-2 px-5' onClick={this.handleModalConfirm}>{confirmButtonText}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>

                {this.state.isModalVisible &&
          <div>
              <div className='popup-wrapper' onClick={this.handleModalCancel} role='dialog'>
                  <div className='popup' onClick={(e) => e.stopPropagation()} style={modalStyle}>
                      <span className='close' onClick={this.handleModalCancel}>Close</span>

                      <h1>{modalHeader}</h1>
                      <p>{modalText}</p>

                      <div className='actions text-center'>
                          <button className='btn btn-secondary mx-2 px-5' onClick={this.handleModalCancel}>{modalCancelButtonText}</button>
                          {modalConfirmButtonText &&
                            <button className='btn btn-primary mx-2 px-5' onClick={this.handleModalConfirm}>{modalConfirmButtonText}</button>
                          }
                      </div>
                  </div>
              </div>
          </div>
                }
            </div>
        );
    }
}

export default PatientNew;
